import { Injectable } from '@angular/core';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { User, UserData, UserService } from '@klickdata/core/user';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserListingService extends UserService implements TableHttpService<User> {
    public fetchData(source: TableSource<User>): Observable<ResponseData<User[]>> {
        const req = this.builder.get<UserData[]>(this.resourceUrl);
        if (source.filter?.filter?.filters?.findIndex((filter) => filter.property === 'customer') === -1) {
            req.param('customer', this.customer_id);
        }
        req.param('eager', 'activations,tags');
        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);

        return req.request().pipe(
            map((res: PaginatorResponse<UserData[]>) => {
                return {
                    data: res.data.map((user) => this.mapUser(user)),
                    notify: res.notify,
                    more: res.more,
                    paginator: res.paginator,
                };
            })
        );
    }
}
